import './SubscriptionRequiredMessage.sass';

import React, { FC, useCallback, useEffect } from 'react';
import { UnitPhoto } from '$shared/components';
import { SubscriptionRequiredMessageProps } from './SubscriptionRequiredMessage.interface';
import { useTranslator, useUserInfo } from '$hooks';
import { Button } from '$uikit';
import { goTo } from '$navigation/helper';
import { SUBSCRIPTION_ADULT } from '$shared/constants/pages';
import { scrollToBottom, statReachGoal } from '$utils';

export const SubscriptionRequiredMessage: FC<SubscriptionRequiredMessageProps> = (props) => {
  const { peerId } = props;
  const peer = useUserInfo(peerId);
  const t = useTranslator();

  useEffect(() => {
    scrollToBottom('chat_history');
  }, []);

  const handlePaywall = useCallback(() => {
    statReachGoal('show_paywall_from_message');
    goTo(SUBSCRIPTION_ADULT, {
      target: 'message',
      target_model: peerId,
    });
  }, [peerId]);

  return (
    <div className="SubscriptionRequiredMessage" onClick={handlePaywall}>
      <div className="SubscriptionRequiredMessage__cont">
        <UnitPhoto unit={peer} size="small" />
        <div className="SubscriptionRequiredMessage__info">
          <div className="SubscriptionRequiredMessage__info__message">
            <b>{peer.firstName}</b> {t('im_subscription_required_message')}
          </div>
          <div className="SubscriptionRequiredMessage__info__action">
            <Button size="small">{t('im_subscription_required_message_btn')}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
